module.exports = "/_next/static/images/offer-old-c36f0dab5dfc1119242de1cc0d59b774.svg";